import '@formatjs/intl-locale/polyfill'
import 'react-app-polyfill/ie9' // IE 9
import 'react-app-polyfill/stable' // All others
import '@formatjs/intl-displaynames/polyfill'
import '@formatjs/intl-displaynames/locale-data/en' // locale-data for en
import React from 'react'
import ReactDOM from 'react-dom'

import './index.css'
import './i18n/i18n'
import { App } from './App'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
